import {KuduClient} from '../../Services/KuduApi';
import {BotAppCIState} from '../Views/BotAppContinuousIntegration';
import {ArmClient, SourceControl} from "../../Services/ArmApi";
import {parseUrl} from "../../../../Intercom.ReactUI/Utils/Url";

function setupRemoteRepo(client: KuduClient, armClient: ArmClient, 
  rsrcId: string,
  scmInfo: BotAppCIState) : JQueryPromise<BotAppCIState> {
  let args : string[] = [];
  const scmHost = parseUrl(scmInfo.hostUrl);
  const hostUrl = `https://${scmHost ? scmHost.hostname : ''}`;

  if (scmInfo.repoProvider == 'vso') {
    args.push(`PostDeployScripts\\setupVsoRemoteRepo.cmd`);
    args.push(hostUrl);
    args.push(scmInfo.repoUserName);
    args.push(scmInfo.repoToken);
  } else {
    args.push(`PostDeployScripts\\setupGithubRemoteRepo.cmd`);
    args.push(scmInfo.repoUserName);
    args.push(scmInfo.repoToken);
  }
  let projName : string = null;
  let repoUrl : string = null;
  let result: BotAppCIState = null;
  return client.settings.then(settings => {
    projName = settings['WEBSITE_SITE_NAME'];
    switch (scmInfo.repoProvider) {
      case 'vso':
        repoUrl = `${hostUrl}/_git/${projName}`;
        break;
      case 'github':
        repoUrl = `https://github.com/${scmInfo.repoUserName}/${projName}.git`
        break;
    }
    args.push(projName);
    return $.Deferred<string>().resolve(projName);
  })
  .then( proj => {
    return client.command(args.join(' '), 'site\\wwwroot');
  })
  .then(f => {
    if (!f) {
      return $.Deferred<BotAppCIState>().reject(`${args[0]} failed`);
    }
    return $.Deferred<BotAppCIState>().resolve(_.extend({}, scmInfo, {
      repoUrl: repoUrl
    }));
  })
  .then(state => {
    result = state;
    return armClient.setupContinuousIntegration(rsrcId, {
      repoUrl: repoUrl,
      branch: 'master',
      token: scmInfo.repoToken,
      isManualIntegration: false,
      deploymentRollbackEnabled: false,
      isMercurial: false
    });
  })
  .then(() => {
    return $.Deferred<BotAppCIState>().resolve(result);
  });
}

export default setupRemoteRepo;


// WEBPACK FOOTER //
// ./Client/v4/Services/setupRemoteRepo.ts